import React, { useState } from "react";
import MainBanner from "../../Components/MainBanner";
import AskSection from "../../Components/AskSection";
import HelpSection from "../../Components/HelpSection";
import AssignmentSection from "../../Components/AssignmentSection";
import LiveHelpSection from "../../Components/LiveHelpSection";
import HelpSteps from "../../Components/HelpSteps";
import BenefitsSection from "../../Components/BenefitsSection";
import WorldWide from "../../Components/WorldWide";
import ReadMoreSection from "../../Components/ReadMoreSection";
import CommonForm from "./Form/CommonForm";
import ScrollTop from "../../Components/Buttons/ScrollTop";
import ReferralProgram from "../../Components/ReferralProgram";
import Universities from "../../Components/Universities";
import { Helmet } from "react-helmet";
import WhatsAppCMP from "../../Components/WhatsApp";
import GatewaySolution from "../../Components/GatewaySolution";
const HomePage = () => {
  const categoryId = "6568bbce652c801ff8766635";
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [typeData, setTypeData] = useState("");
  const toggle = () => {
    setIsModelOpen(!isModelOpen);
  };

  return (
    <>
      <Helmet>
        <title>
          Home | Get Personalized Academic Success with DoubtQ | Online Question
          Help
        </title>
        <meta name="description" content="Welcome to the Home Page of DoubtQ" />
        <meta property="og:title" content="Home Page - DoubtQ" />
        <meta
          property="og:description"
          content="Explore personalized academic help on DoubtQ's Home Page"
        />
      </Helmet>
      <MainBanner
        id={categoryId}
        setIsModelOpen={setIsModelOpen}
        setTypeData={setTypeData}
        isHome={true}
      />
      <AskSection />
      <WhatsAppCMP />
      <HelpSection setIsModelOpen={setIsModelOpen} setTypeData={setTypeData} />
      <AssignmentSection
        setIsModelOpen={setIsModelOpen}
        setTypeData={setTypeData}
      />
      <LiveHelpSection
        setIsModelOpen={setIsModelOpen}
        setTypeData={setTypeData}
      />
      <ReferralProgram />
      <HelpSteps subCategoryId={categoryId} />
      <GatewaySolution />
      <BenefitsSection
        subCategoryId={categoryId}
        setIsModelOpen={setIsModelOpen}
      />
      <Universities setIsModelOpen={setIsModelOpen} />
      <WorldWide />
      <ReadMoreSection />
      {isModelOpen ? (
        <CommonForm isOpen={isModelOpen} toggle={toggle} typeData={typeData} />
      ) : (
        <></>
      )}
      <ScrollTop />
    </>
  );
};

export default HomePage;
